<template>
    <v-container class="grey lighten-5" fluid>
        <v-col class="px-2 pt-2">
            <v-row>
                <v-col md="4" class="pt-0">
                    <v-select
                        v-model="report"
                        :items="reports"
                        item-value="id"
                        item-text="reportName"
                        label="Select a report"
                        dense
                    ></v-select>
                </v-col>
            </v-row>

            <v-card v-if="report" class="pa-4 mx-0">
                <report1 v-if="report == 1"></report1>
                <report2 v-if="report == 2"></report2>
                <report3 v-if="report == 3"></report3>
                <report4 v-if="report == 4"></report4>
                <report5 v-if="report == 5"></report5>
                <report6 v-if="report == 6"></report6>
                <report7 v-if="report == 7"></report7>
                <report8 v-if="report == 8"></report8>
                <report9 v-if="report == 9"></report9>
                <report10 v-if="report == 10"></report10>
                <report11 v-if="report == 11"></report11>
                <report12 v-if="report == 12"></report12>
                <report13 v-if="report == 13"></report13>
                <report14 v-if="report == 14"></report14>
                <report15 v-if="report == 15"></report15>
                <report16 v-if="report == 16"></report16>
                <report17 v-if="report == 17"></report17>
                <report18 v-if="report == 18"></report18>
            </v-card>
        </v-col>
    </v-container>
</template>

<script>
import axios from 'axios';
import Report1 from '@/components/reports/Merchants12WeekRevenue.vue';
import Report2 from '@/components/reports/client/MotoTransactions.vue';
import Report3 from '@/components/reports/TransactionsAnalysis.vue';
import Report4 from '@/components/reports/TpProcessing.vue';
import Report5 from '@/components/reports/ApprovalRates.vue';
import Report6 from '@/components/reports/MerchantAccountInfo.vue';
import Report7 from '@/components/reports/MerchantsValueVolume.vue';
import Report8 from '@/components/reports/BinApprovalRates.vue';
import Report9 from '@/components/reports/AcquirersValueVolume.vue';
import Report10 from '@/components/reports/ChargebackStats.vue';
import Report11 from '@/components/reports/Schedules.vue';
import Report12 from '@/components/reports/SchedulesForecaster.vue';
import Report13 from '@/components/reports/CallLogs.vue';
import Report14 from '@/components/reports/RevenueComparison.vue';
import Report15 from '@/components/reports/RevenueSource.vue';
import Report16 from '@/components/reports/UnclaimedPreAuths.vue';
import Report17 from '@/components/reports/client/Last30DaysTransactions.vue';
import Report18 from '@/components/reports/client/RevenueByCountry.vue';

export default {
    components: {
        'report1': Report1,
        'report2': Report2,
        'report3': Report3,
        'report4': Report4,
        'report5': Report5,
        'report6': Report6,
        'report7': Report7,
        'report8': Report8,
        'report9': Report9,
        'report10': Report10,
        'report11': Report11,
        'report12': Report12,
        'report13': Report13,
        'report14': Report14,
        'report15': Report15,
        'report16': Report16,
        'report17': Report17,
        'report18': Report18,
    },
    data() {
        return {
            reports: [],
            report: null
        }
    },
    beforeMount() {
        this.getReports();
    },
    methods: {
        getReports() {
            if(this.$store.getters.role <= 2) {
                axios({
                method: 'get',
                url: `get-reports`,
                config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                })
                .then(response => {
                    this.reports = response.data;
                })
                .catch(e => {
                    this.errors.push(e)
                })
            }
            else {
                axios({
                method: 'post',
                url: `get-reports-client`,
                data: { userId: this.$store.state.user.id },
                config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                })
                .then(response => {
                    this.reports = response.data;
                })
                .catch(e => {
                    this.errors.push(e)
                })
            }
        }
    }
}
</script>

<style>

</style>